import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import Vuex from 'vuex';
import {router} from "@/router";
import {store} from "@/storage";
import VueDragTree from 'vue-drag-tree';
import 'vue-drag-tree/dist/vue-drag-tree.min.css';
import helper from "@/mixin/helper"

Vue.config.productionTip = false

Vue.use(VueDragTree);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuex);
Vue.mixin(helper);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
